import { usePathsV2 } from 'core/services/navigation/usePathsV2';
import { CandidateProfileDetail } from 'modules/candidate-profile/components/CandidateProfileDetail';
import { CandidateProfileDetailType } from 'modules/candidate-profile/types/CandidateProfileDetailProps';

export const TalentPoolCandidateProfileDetailsPage: React.FC = () => {
  const { getPathParams } = usePathsV2();
  const { talentPoolId, candidateProfileId } =
    getPathParams.TALENT_POOL_CANDIDATE_PROFILE_DETAILS();

  return (
    <CandidateProfileDetail
      type={CandidateProfileDetailType.TALENT_POOL_CANDIDATE_PROFILE_DETAILS}
      candidateProfileId={candidateProfileId}
      talentPoolId={talentPoolId}
    />
  );
};
